import { RadioIcon } from "../../Atoms/RadioIcon";
import { RadioSquare } from "../../Atoms/RadioSquare";
import * as S from "./styles";
import { useSatisfactionSurvey } from "./useSatisfactionSurvey";
import { Button } from "../../Atoms/Button";
import { TextInput } from "../../Atoms/TextInput";
import { TipoPerguntaEnum } from "../../../enums/tipoPergunta";

export const SatisfactionSurveyTemplate = () => {
  const { ICONS, answered, submitForm, form, setForm, questions } =
    useSatisfactionSurvey();

  return (
    <S.Container>
      {answered ? (
        <S.Confirmation>
          <img
            src="/assets/svgs/icon-confirmation.svg"
            alt="icone confirmacao"
          />

          <h2>Pesquisa concluída!</h2>

          <p>
            Sua opinião foi registrada com sucesso e será essencial para
            aprimorarmos nossos serviços.
          </p>

          <span>Muito obrigado!</span>
        </S.Confirmation>
      ) : questions?.length > 0 ? (
        <S.Wrapper>
          <h1>Pesquisa de Satisfação!</h1>

          <S.FormSatisfactionSurvey onSubmit={submitForm}>
            {questions?.map((p, idx) => {
              if (p.tipo === TipoPerguntaEnum.ESCALA) {
                return (
                  <div key={idx}>
                    <S.Question>{p.descricao}</S.Question>

                    <S.WrapperRadio>
                      {Array.from(
                        { length: p.valorFinal - p.valorInicial },
                        (_, i) => i + p.valorInicial + 1
                      ).map((i, index) => (
                        <RadioIcon
                          required={p.obrigatorio}
                          key={index}
                          icon={ICONS[index].icon}
                          label={ICONS[index].label}
                          name={"item" + p?.ordem}
                          value={i}
                          checked={
                            i ===
                            form?.respostas?.find(
                              (r) => r?.uuidPergunta === p?.uuid
                            )?.valorEscala
                          }
                          onChange={() => {
                            const hasResposta = form?.respostas?.some(
                              (r) => r?.uuidPergunta === p?.uuid
                            );

                            if (hasResposta) {
                              const respostas = form?.respostas?.map((r) => {
                                if (r?.uuidPergunta === p.uuid) {
                                  return {
                                    ...r,
                                    valorEscala: i,
                                  };
                                }

                                return r;
                              });

                              return setForm({
                                ...form,
                                respostas: respostas,
                              });
                            }

                            const resposta = {
                              uuidPergunta: p?.uuid,
                              valorBooleano: null,
                              valorTexto: "",
                              valorEscala: i,
                            };

                            setForm({
                              ...form,
                              respostas: [...form?.respostas, resposta],
                            });
                          }}
                        />
                      ))}
                    </S.WrapperRadio>
                  </div>
                );
              }
              if (p.tipo === TipoPerguntaEnum.BOOLEANO) {
                return (
                  <div key={idx}>
                    <S.Question>{p.descricao}</S.Question>

                    <S.WrapperRadioSquare>
                      <RadioSquare
                        name={p.uuid}
                        required={p.obrigatorio}
                        label="Sim"
                        value={"SIM"}
                        checked={
                          form?.respostas?.find(
                            (r) => r?.uuidPergunta === p?.uuid
                          )?.valorBooleano
                        }
                        onChange={() => {
                          const hasResposta = form?.respostas?.some(
                            (r) => r?.uuidPergunta === p?.uuid
                          );

                          if (hasResposta) {
                            const respostas = form?.respostas?.map((r) => {
                              if (r?.uuidPergunta === p.uuid) {
                                return {
                                  ...r,
                                  valorBooleano: true,
                                };
                              }

                              return r;
                            });

                            return setForm({
                              ...form,
                              respostas: respostas,
                            });
                          }

                          const resposta = {
                            uuidPergunta: p?.uuid,
                            valorBooleano: true,
                            valorTexto: "",
                            valorEscala: 0,
                          };

                          setForm({
                            ...form,
                            respostas: [...form?.respostas, resposta],
                          });
                        }}
                      />

                      <RadioSquare
                        name={p.uuid}
                        required={p.obrigatorio}
                        label="Não"
                        value={"NAO"}
                        checked={
                          form?.respostas?.find(
                            (r) => r?.uuidPergunta === p?.uuid
                          )?.valorBooleano === false
                        }
                        onChange={() => {
                          const hasResposta = form?.respostas?.some(
                            (r) => r?.uuidPergunta === p?.uuid
                          );

                          if (hasResposta) {
                            const respostas = form?.respostas?.map((r) => {
                              if (r?.uuidPergunta === p.uuid) {
                                return {
                                  ...r,
                                  valorBooleano: false,
                                };
                              }

                              return r;
                            });

                            return setForm({
                              ...form,
                              respostas: respostas,
                            });
                          }

                          const resposta = {
                            uuidPergunta: p?.uuid,
                            valorBooleano: false,
                            valorTexto: "",
                            valorEscala: 0,
                          };

                          setForm({
                            ...form,
                            respostas: [...form?.respostas, resposta],
                          });
                        }}
                      />
                    </S.WrapperRadioSquare>
                  </div>
                );
              }

              if (p.tipo === TipoPerguntaEnum.TEXTO) {
                return (
                  <div key={idx}>
                    <S.Question>{p.descricao}</S.Question>

                    <TextInput
                      required={p.obrigatorio}
                      value={
                        form?.respostas?.find(
                          (r) => r?.uuidPergunta === p?.uuid
                        )?.valorTexto
                      }
                      onChange={(e) => {
                        const hasResposta = form?.respostas?.some(
                          (r) => r?.uuidPergunta === p?.uuid
                        );

                        if (hasResposta) {
                          const respostas = form?.respostas?.map((r) => {
                            if (r?.uuidPergunta === p.uuid) {
                              return {
                                ...r,
                                valorTexto: e.target.value,
                              };
                            }

                            return r;
                          });

                          return setForm({
                            ...form,
                            respostas: respostas,
                          });
                        }

                        const resposta = {
                          uuidPergunta: p?.uuid,
                          valorBooleano: null,
                          valorTexto: e.target.value,
                          valorEscala: 0,
                        };

                        setForm({
                          ...form,
                          respostas: [...form?.respostas, resposta],
                        });
                      }}
                    />
                  </div>
                );
              }

              return null;
            })}

            <div>
              <Button>Enviar</Button>
            </div>
          </S.FormSatisfactionSurvey>
        </S.Wrapper>
      ) : null}
    </S.Container>
  );
};
